import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import Select from 'react-select/async';
import fetch from 'unfetch';
import { useStoreState, useStoreActions } from 'easy-peasy';

// import { getDirectMatches } from '~/utils';
import Option from './Option';

const SearchWrapper = styled.div`
  width: 100%;
  max-width: 420px;
  position: relative;
  font-size: 14px;
`;

const ResetButton = styled.button`
  margin-left: 10px;
  padding: 5px;
  flex-shrink: 0;
  cursor: pointer;
  font-size: 14px;
  display: block;
  padding: 8px 15px;
  border: 1px solid rgb(221, 221, 221);
  background: rgb(238, 238, 238);
  outline: none;
  color: #999;
  user-select: none;

  &:hover {
    background: ${(props) => props.theme.colors.blue};
    color: white;
  }
`;

const SearchInputGroup = styled.div`
  display: flex;
`;

const SearchError = styled.div`
  margin: 5px 0;
  color: ${(p) => p.theme.colors.red};
`;

const StyledSelect = styled(Select)`
  font-size: 14px;
  z-index: 101;
  width: 100%;

  .rc__single-value {
    width: 93%;
  }
`;

const noOptionsMessage = (value) => {
  if (value.inputValue.length < config.search.minCharacters) {
    return null;
  }

  return config.search.notFoundMessage;
};

const loadingMessage = () => config.search.loadingMessage;

const Search = () => {
  const timeoutRef = useRef();
  const dataMap = useStoreState((state) => state.app.dataMap);
  // const data = useStoreState((state) => state.app.data);
  const searchValue = useStoreState((state) => state.app.searchValue);
  const notFound = useStoreState((state) => state.app.notFound);
  const setValue = useStoreActions((actions) => actions.app.setValue);
  const reset = useStoreActions((actions) => actions.app.reset);

  const [inputValue, setInputValue] = useState(searchValue);
  const [loadedOptions, setLoadedOptions] = useState([]);

  const loadOptions = async (value) => {
    // const directMatches = getDirectMatches(value, data);

    return new Promise((yep) => {
      // if (directMatches.length >= 10) {
      //   return yep(directMatches.slice(0, 10));
      // }

      // if (value.length < config.search.minCharacters) {
      //   return yep(directMatches);
      // }

      if (value && value.length < config.search.minCharacters) {
        return null;
      }

      window.clearTimeout(timeoutRef.current);

      timeoutRef.current = setTimeout(async () => {
        const response = await fetch(`${config.search.apiUrl}?search=${value}`);
        const responseData = await response.json();
        const responseIds = responseData.map((d) => d.id);
        // const directMatchIds = directMatches.map((d) => d.value);
        const optionIds = [
          ...responseIds,
          // ...new Set(directMatchIds.concat(responseIds)),
        ].slice(0, 10);

        const options = optionIds
          .map((id) => dataMap.get(id) || null)
          .filter((d) => d);

        setLoadedOptions(options);
        yep(options);
      }, 300);
    });
  };

  const clearValue = () => {
    setValue(null);
  };

  const onChange = (option) => {
    if (option && option.value) {
      return setValue(option.value);
    }
    return clearValue();
  };

  const onFocus = () => {
    // setInputValue('');
  };

  const onBlur = () => {
    if (!inputValue && searchValue) {
      setInputValue(searchValue);
    }
  };

  const onReset = () => {
    reset();
  };

  useEffect(() => {
    setInputValue(searchValue || null);
  }, [searchValue]);

  return (
    <SearchWrapper>
      <SearchInputGroup>
        <StyledSelect
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          value={inputValue}
          loadOptions={loadOptions}
          defaultOptions={loadedOptions}
          cacheOptions
          loadingMessage={loadingMessage}
          noOptionsMessage={noOptionsMessage}
          placeholder={config.search.placeholder}
          formatOptionLabel={Option}
          blurInputOnSelect
          classNamePrefix="rc"
          components={{
            IndicatorsContainer: () => null,
          }}
        />
        <ResetButton onClick={onReset} alt="Grafik zurücksetzen">
          ↻
        </ResetButton>
      </SearchInputGroup>
      {notFound && <SearchError>Keine Daten für diesen Beruf</SearchError>}
    </SearchWrapper>
  );
};

export default Search;
